import Link from 'next/link';
import Container from 'components/container';

import { LIBUM_URL } from 'shared/constants/globals';
import {
  ContentHeadline,
  ContentList,
  ContentListItem,
  ContentListItemMeta,
  ContentMain,
  ContentPanel,
} from 'shared/styles/components';
import { LEGAL_DOCS } from 'shared/data/legal-docs';

import DOWNLOAD_ICON from 'public/icons/eva/download.svg';

export default function Legal() {
  const title = 'Legal | Libum';
  const description = '';
  const keywords =
    'Libum,Libum legal,Libum MSA,Libum SLA,Libum privacy policy,Libum legal agreements,Libum legal policies';
  const url = `${LIBUM_URL}/legal`;

  return (
    <Container title={title} description={description} keywords={keywords} url={url} socialCard="legal">
      <div style={{ width: '100%' }}>
        <ContentPanel>
          <ContentHeadline>
            <h1>Legal Docs</h1>
            <p>Latest agreements and policies from the Libum team.</p>
          </ContentHeadline>
        </ContentPanel>
        <ContentPanel>
          <ContentMain>
            <ContentList>
              {...LEGAL_DOCS.map((doc) => (
                <ContentListItem key={doc.id}>
                  <h3>
                    <Link href={`/legal/` + doc.id}>{doc.title}</Link>
                  </h3>
                  <p>{doc.description}</p>
                  <ContentListItemMeta>
                    <Link href={`/docs/` + doc.fileName} target="_blank" locale={false} download>
                      <DOWNLOAD_ICON />
                      Download
                    </Link>
                    <span>{doc.currentAsOf}</span>
                  </ContentListItemMeta>
                </ContentListItem>
              ))}
            </ContentList>
          </ContentMain>
        </ContentPanel>
      </div>
    </Container>
  );
}
